export default __webpack_public_path__ + "static/media/botao_rid_locucao.f17733ab.svg";